import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 登录
 */
const PostLogin = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/login/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 广东民族医循证用户自主注册站外用户自主注册
 * @url https://app.apifox.com/link/project/3858755/apis/api-246455259
 * @api /api/gd_mzy_xunzheng/xunzheng_users/register/
 * @param username
 * @param password
 */
const PostRegister = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/gd_mzy_xunzheng/xunzheng_users/register/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 退出登录
 */
const LoginOut = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/logout/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 获取当前用户信息
 */
const GetCurUserInfo = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("/api/system/user/get_user_info/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 上传文件
 */
const UploadFile = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/system/file/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取专栏翻页列表
 * https://app.apifox.com/project/3858755/apis/api-157305064
 */
const GetArticleList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/text/article/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取字典列表
 * https://app.apifox.com/project/3858755/apis/api-159637116
 */
const GetDictionary = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 搜索筛选返回打平的字典列表
 * https://app.apifox.com/project/3858755/apis/api-159637116
 * @param values(必填) 字典value值列表，逗号分割
 */
const GetDictionaryData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/all_flat_list/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增字典选项
 * https://app.apifox.com/project/3858755/apis/api-148321976
 * @param value(必填)  
 * @param parent 父级
 * @param status  true/false
 */
const PostAddDictionary = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/system/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑字典选项
 * https://app.apifox.com/project/3858755/apis/api-148321976
 * @param value(必填)  
 * @param parent 父级
 * @param status  true/false
 */
const PatchEditDictionary = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch('api/system/dictionary/' + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除字典选项
 * https://app.apifox.com/project/3858755/apis/api-159637116
 * @param path id
 */
const DelDictionary = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete('api/system/dictionary/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增科普
 * https://app.apifox.com/project/3858755/apis/api-157305065
 * @param name 标题
 */
const PostAddKepu = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/text/article/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑科普
 * https://app.apifox.com/project/3858755/apis/api-157305074
 * @param path id
 */
const PatchEditKepu = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch('api/text/article/' + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除科普
 * https://app.apifox.com/project/3858755/apis/api-157305074
 */
const DelKepu = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete('api/text/article/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取科普列表
 * https://app.apifox.com/project/3858755/apis/api-157305064
 */
const GetKepuList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/text/article/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取科普列表(不做登录拦截)
 * https://app.apifox.com/project/3858755/apis/api-171674669
 */
const GetKepuVisitorList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/text/article/list_visitor/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 查看科普详情
 * https://app.apifox.com/project/3858755/apis/api-157305074
 * @param path id
 */
const GetKepuDetail = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/text/article/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增需求反馈定义
 * @url https://app.apifox.com/link/project/3858755/apis/api-246448936
 * @api /api/gd_mzy_xunzheng/xunzheng_feedback/
 * @param path id
 */
const PostFeedback = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/gd_mzy_xunzheng/xunzheng_feedback/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 返回全部数据列表-需求反馈定义
 * @url https://app.apifox.com/link/project/3858755/apis/api-246448940
 * @api /api/gd_mzy_xunzheng/xunzheng_feedback/list_all/
 */
const GetFeedbackAll = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/gd_mzy_xunzheng/xunzheng_feedback/list_all/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取列表需求反馈定义
 * @url https://app.apifox.com/link/project/3858755/apis/api-246448935
 * @api /api/gd_mzy_xunzheng/xunzheng_feedback/
 */
const GetFeedbackList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/gd_mzy_xunzheng/xunzheng_feedback/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 文献翻页列表文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-247844032
 * @api /api/text/paper/
 */
const GetPaperList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/text/paper/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-247844033
 * @api /api/text/paper/
 */
const PostPaper = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/text/paper/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 部分更新文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-247844042
 * @api /api/text/paper/{id}/
 */
const PatchPaper = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch('api/text/paper/' + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-247844043
 * @api /api/text/paper/{id}/
 */
const DeletePaper = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete('api/text/paper/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取各维度分布echarts数据文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-248203202
 * @api /api/text/paper/get_echarts_data/
 */
const GetPaperEcharts = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/text/paper/get_echarts_data/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取详情文献
 * @url https://app.apifox.com/link/project/3858755/apis/api-247844040
 * @api /api/text/paper/{id}/
 */
const GetPaperDetail = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('/api/text/paper/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增话题
 * @url https://app.apifox.com/link/project/3858755/apis/api-249736187
 * @api /api/gd_mzy_xunzheng/xunzheng_topic/
 */
const PostTopic = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/gd_mzy_xunzheng/xunzheng_topic/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取列表话题
 * @url https://app.apifox.com/link/project/3858755/apis/api-249736186
 * @api api/gd_mzy_xunzheng/xunzheng_topic/
 */
const GetTopicList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/gd_mzy_xunzheng/xunzheng_topic/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增话题回复
 * @url https://app.apifox.com/link/project/3858755/apis/api-249736175
 * @api /api/chat/topic_reply/
 */
const PostReply = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/chat/topic_reply/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 返回全部数据列表-话题回复
 * @url https://app.apifox.com/link/project/3858755/apis/api-249736179
 * @api /api/chat/topic_reply/list_all/
 */
const GetReplyList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get('api/chat/topic_reply/list_all/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 循证研究方案生成gpt
 * @url https://app.apifox.com/link/project/3858755/apis/api-249736179
 * @api /api/gd_mzy_xunzheng/xunzheng_gpt/research_plan_create/
 */
const PostGptPlan = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/gd_mzy_xunzheng/xunzheng_gpt/research_plan_create/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 样本量估计接口
 * @url https://app.apifox.com/link/project/3858755/apis/api-252482009
 * @api /api/gd_mzy_xunzheng/xunzheng_stat/sample_count/
 */
const PostSampleCount = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post('api/gd_mzy_xunzheng/xunzheng_stat/sample_count/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export {
    PostLogin, LoginOut, GetCurUserInfo, PostRegister,
    UploadFile,
    GetArticleList,
    GetDictionary, GetDictionaryData, PostAddDictionary, PatchEditDictionary, DelDictionary,
    PostAddKepu, PatchEditKepu, GetKepuList, GetKepuVisitorList, DelKepu, GetKepuDetail,
    PostFeedback, GetFeedbackAll, GetFeedbackList,
    GetPaperList, GetPaperEcharts, GetPaperDetail, PostPaper, DeletePaper, PatchPaper,
    PostTopic, GetTopicList, PostReply, GetReplyList, PostGptPlan, PostSampleCount
}